import { CheckInPageProps } from "./type";
import { Button, Typography, useToast } from "@fanka/ui-admin";
import { PageLayout } from "@on-site/layouts/PageLayout";
import { EventCard } from "@on-site/features/event/ui/EventCard";
import { useState } from "react";
import { CheckInComplete } from "@on-site/components/pages/checkIn/ui/CheckInComplete";
import { parseToString } from "@on-site/utils/parse";
import { useAppApiSWRPut } from "@on-site/libs/swr/useAppApiSWRMutation";
import { useParams } from "@on-site/libs/router";
import { RadioEventCard } from "@on-site/features/event/ui/RadioEventCard";
import { useLocalViewsStore } from "@on-site/features/top/hooks/useLocalViewsStore";
import { useEffect } from "react";

// TODO: eventCondition配下に移動
export const CheckInPage = ({ events }: CheckInPageProps) => {
  const { resetView } = useLocalViewsStore();

  const { clinicId } = useParams();

  const { openToast } = useToast();

  const [isCompleted, setIsCompleted] = useState(false);

  const [eventId, setEventId] = useState<string | null>(null);
  useEffect(() => {
    if (events?.length > 0) {
      setEventId(events[0].id);
    }
  }, [events]);

  const isMultipleEvents = events.length > 1;

  const checkIn = useAppApiSWRPut("/api/v2/on-site/clinics/{clinicId}/events/{eventId}", {
    params: {
      path: {
        clinicId: parseToString(clinicId, ""),
        eventId: parseToString(eventId, ""),
      },
    },
    onSuccess: () => {
      setIsCompleted(true);
    },
    onError: (error) => {
      if (error instanceof Error) {
        openToast({ type: "error", description: error.message });
      }
    },
  });

  return (
    <PageLayout>
      {isCompleted ? (
        <CheckInComplete onStartOver={resetView} isLoading={checkIn.isMutating} />
      ) : (
        <div className="bg-base-100 mx-auto flex h-full w-full flex-col items-center justify-center overflow-hidden">
          <div className="flex max-w-[424px] flex-col gap-y-4 text-center">
            <Typography.Heading type="h1">ようこそ</Typography.Heading>
            <Typography.Heading type="h1">{`${events[0].patient.fullName} 様`}</Typography.Heading>
          </div>
          <section className="mt-12 w-full">
            <div className="flex flex-col gap-y-1 text-center">
              <Typography.UiText size="md" bold>
                本日のご予約
              </Typography.UiText>
              {isMultipleEvents && (
                <Typography.UiText size="md">チェックインする予約を選択してください</Typography.UiText>
              )}
            </div>
            <div className="mx-auto mt-4 flex w-full max-w-fit gap-x-4 overflow-auto pb-12">
              {events.map((event) => (
                <div className="w-[376px] shrink-0">
                  {isMultipleEvents ? (
                    <RadioEventCard
                      event={event}
                      isSelected={event.id === eventId}
                      onClick={() => setEventId(event.id)}
                    />
                  ) : (
                    <EventCard event={event} />
                  )}
                </div>
              ))}
            </div>
          </section>
          <div className="flex w-full max-w-[424px] flex-col gap-y-4 px-6">
            <Button
              size="lg"
              block
              onClick={() => checkIn.trigger({ status: "WAIT_FOR_CONSULTATION" })}
              isLoading={checkIn.isMutating}
            >
              チェックインする
            </Button>
            <Button size="lg" styleType="outline" block onClick={resetView}>
              最初からやりなおす
            </Button>
          </div>
        </div>
      )}
    </PageLayout>
  );
};
